var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showtimeout)?_c('timeout',{attrs:{"seconds_to_final":60,"loginURL":_vm.loginURL}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }